import {
  DisplayOptionSetting,
  DisplayOptionsSettingsEndpoint,
  DisplayOptionSettingsValue,
  DisplayOption,
  DisplayOptionsSettings,
} from '@services/resources/users/displayOptions/types';

const flatDisplayOptionsSettings = (arr: DisplayOptionSettingsValue[]): DisplayOptionSetting[] =>
  arr
    .map(({ values, elements }) => {
      if (elements?.length)
        return elements.map((el) => ({ [el.attributeName]: el.value }) as DisplayOptionSetting);
      if (values?.length) return flatDisplayOptionsSettings(values);
      else return [];
    })
    .flat();

export const getWorkloadDisplayOptionsSettingsEndpoint = (
  type?: string,
  isPhone = false,
): DisplayOptionsSettingsEndpoint => {
  if (isPhone && (!type || type === 'day' || type === 'week')) return 'mobileDayCalendar';
  if (isPhone && type === 'agenda') return 'mobileAgendaCalendar';
  if (type === 'agenda') return 'agendaCalendar';
  if (!type || type === 'week') return 'weekCalendar';
  if (type === 'day') return 'dayCalendar';
  if (type === 'two-week') return 'twoWeekCalendar';
  return 'monthCalendar';
};

export const parseDisplayOptionsSettings = (
  arr: DisplayOptionSettingsValue[],
): DisplayOptionSetting => {
  let result: DisplayOptionSetting = {};
  const settings = flatDisplayOptionsSettings(arr);
  settings.forEach((el) => {
    result = { ...result, ...el };
  });
  return result;
};

export const getDisplayOptionsSettings = (
  data: DisplayOption[],
  endpoint: DisplayOptionsSettingsEndpoint,
) => {
  return data.find((el) => el.endpoint === endpoint)?.settings || {};
};

export const getDisplayOptionsSettingsValues = (
  data: DisplayOptionsSettings[],
  endpoint: DisplayOptionsSettingsEndpoint,
) => {
  return data.find((el) => el.endpoint === endpoint)?.values || [];
};
